<template>
  <div class="carousel__wrapper">
    <Agile
      ref="carousel"
      :initialSlide="activedWeekIndex"
      class="carousel__inner"
      :dots="false"
      :infinite="false"
      @before-change="setActivedWeek($event)"
    >
      <div
        v-for="(week, weekIndex) in weeks"
        :key="weekIndex"
        class="calendar__week"
      >
        <div
          v-for="(day, dayIndex) in week"
          :key="dayIndex"
          :class="['calendar__day', { active: isSelectedDay(day) }]"
          @click="!isSelectedDay(day) && setSelectedDay(day)"
        >
          <span class="calendar__day--weekDay textOverflow">
            {{ day.format('dddd').replace(/-feira/i, '') }}
          </span>
          <span class="calendar__day--monthDay">
            {{ day.format('DD') }}
          </span>
        </div>
      </div>
    </Agile>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { VueAgile } from 'vue-agile';

export default {
  name: 'WeekCarousel',

  components: { Agile: VueAgile },

  computed: {
    ...mapState('dashboard/calendar', [
      'activedWeekIndex',
      'weeks',
      'selectedDay',
    ]),
    ...mapState('dashboard', ['isSidebarOpened']),
  },

  watch: {
    isSidebarOpened() {
      setTimeout(this.$refs.carousel.reload, 400);
    },
  },

  methods: {
    ...mapActions('dashboard/calendar', [
      'setSelectedDay',
      'setActivedWeekIndex',
    ]),
    isSelectedDay(day) {
      return day.isSame(this.selectedDay, 'day');
    },
    setActivedWeek({ nextSlide }) {
      this.setActivedWeekIndex(nextSlide);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>

<style lang="scss">
@import './unscopedStyle.scss';
</style>
